import FAQModule from './FAQModule';

export default FAQModule;